export const INSERT_CUSTOMER = 'customer/insert'
export const UPDATE_CUSTOMER = 'customer/update'

export const SUBSCRIBED_CUSTOMER_STATUS = 'subscribed'
export const UNSUBSCRIBED_CUSTOMER_STATUS = 'unsubscribed'
export const UNPAID_CUSTOMER_STATUS = 'unpaid'
export const TRIAL_CUSTOMER_STATUS = 'trial_period'
